export default __webpack_public_path__ + "static/media/close.c40680da.svg";